const STUDENT_REGISTRATION_EVENTS = {
	START: "Student Registration: Start",
	BACK: "Student Registration: Back",
	CUSTOMER_SEGMENT_SUBMIT: "Student Registration: Customer Segment Submit",
	BA_LEVEL_SUBMIT: "Student Registration: BA Level Submit",
	LOCK_SCHEME_SUBMIT: "Student Registration: Lock Scheme Submit",
	USERNAME_REROLL: "Student Registration: Username Reroll",
	USERNAME_SUBMIT: "Student Registration: Username Submit",
	PASSWORD_SUBMIT: "Student Registration: Password Submit",
	TUTORIAL_MODAL_CLOSE: "Student Registration: Tutorial Modal Close",
	SUPPORT_MODAL_CLOSE: "Student Registration: Support Modal Close",
} as const;

module.exports = {STUDENT_REGISTRATION_EVENTS};
